// src/pages/common/reports/R0006/utils/dateUtils.js

import { format, parseISO, differenceInDays } from 'date-fns';

export const formatDateRangeSubtitle = (selectedDateRange, selectedArea = 'Area Summary') => {
  let dateString = '';
  
  if (selectedDateRange?.startDate) {
    if (selectedDateRange.startDate === selectedDateRange.endDate) {
      dateString = format(parseISO(selectedDateRange.startDate), 'MMM dd, yyyy');
    } else {
      const startDate = parseISO(selectedDateRange.startDate);
      const endDate = parseISO(selectedDateRange.endDate);
      dateString = `${format(startDate, 'MMM dd')} - ${format(endDate, 'MMM dd, yyyy')}`;
    }
    
    // Add area name after the date
    return `${dateString} | ${selectedArea}`;
  }
  
  return `No date selected | ${selectedArea}`;
};

export const getDaysCount = (dateRange) => {
  if (!dateRange) return 0;

  if (!dateRange.isRange || dateRange.startDate === dateRange.endDate) {
    return 1;
  }
  
  const start = new Date(dateRange.startDate);
  const end = new Date(dateRange.endDate);
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
};

export const getPendingDaysCount = (pendingSelection) => {
  if (!pendingSelection) return 0;
  
  const start = parseISO(pendingSelection.startDate);
  const end = parseISO(pendingSelection.endDate);
  return differenceInDays(end, start) + 1;
};